import { render } from "./TopbarSaleFr.vue?vue&type=template&id=447d935d"
import script from "./TopbarSaleFr.vue?vue&type=script&lang=js"
export * from "./TopbarSaleFr.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__